import axios from 'axios';
import { getCognitoAuthHeader, getEnvironment } from 'src/_shared/services/utils.js';

// The broker (claus-proxy) always answers HTTP 200 and encodes CLAUS outcomes in the body — either
// data or { error }. Auth/transport failures come back as non-2xx (axios throws). The CLAUS API key
// lives only in the broker; the browser just forwards its Cognito JWT.
const clausProxyUrl = () => {
	const configMode = getEnvironment() === 'dev' ? 'DEV' : 'PROD';
	return process.env[`REACT_APP_${configMode}_CLAUSPROXYURL`];
};

/**
 * Call CLAUS through the broker.
 * @param {string} endpoint  Path beneath /v1, e.g. `/organizations/{id}/integrations`.
 * @param {'GET'|'POST'|'PATCH'|'DELETE'} method
 * @param {any} [data]       Request body for POST/PATCH.
 * @param {{companyId?: string, organizationId?: string}} [scope]  Tenant scope for the broker.
 * @returns {Promise<any>}   The CLAUS response body (throws Error on a CLAUS/broker error).
 */
export async function callClaus(endpoint, method = 'GET', data, scope = {}) {
	const url = clausProxyUrl();
	if (!url) throw new Error('CLAUS proxy URL is not configured (REACT_APP_*_CLAUSPROXYURL).');

	let body;
	try {
		const Authorization = await getCognitoAuthHeader();
		const res = await axios.post(
			url,
			{ endpoint, method, data, companyId: scope.companyId, organizationId: scope.organizationId },
			{ headers: { Authorization } },
		);
		body = res?.data;
	} catch (err) {
		// Broker returned non-2xx (auth/transport). Prefer its { error } body if present.
		const apiError = err?.response?.data?.error;
		throw new Error(apiError || err?.message || 'CLAUS request failed');
	}

	if (body && body.error) throw new Error(body.error);
	return body;
}
